import React, { useState } from "react";
import PersonalLinear from "./Charts/PersonalLinear";
import TeamBars from "./Charts/TeamBars";
import GrayToGoldLinear from "./Charts/GrayToGoldLinear";
import { Link } from "react-router-dom";
import ProductivityChart from "./Charts/ProductivityChart";
import OfflineColumnChart from "../HVI/OfflineColumnChart";
import OfflinePieChart from "../HVI/OfflinePieChart";
import { useTranslation } from "react-i18next";
//import Exporting from 'highcharts/modules/exporting';
import TeamDataColumnChart from "../Organization/TeamDataColumnChart";

const HviChart = (props) => {

  const [selectedHviItem, setSelectedHviItem] = useState(0);
  const [translation] = useTranslation("translations");

  if (!props.hvi) {
    return <div className="hvi-chart-wrap mt-3"></div>;
  }

  const getWeekNumber = (date) => {

    if ( ! date ) return;

    const currentDate = new Date(date);
    const startDate = new Date(currentDate.getFullYear(), 0, 1);
    const days = Math.floor((currentDate - startDate) /
        (24 * 60 * 60 * 1000));
         
    const weekNumber = Math.ceil(days / 7);

    return weekNumber;

  }

  let dates = [];
  let hviValues = [];
  let teamHvi = {
    red: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    yellow: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    green: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  };
  let teamDates = [];
  let teamHviSummaryData = [];
  let teamWeeks = [];
  let teamHviWeeklySummaryData = [];

  if (props.hvi.personal && props.hvi.personal.length > 0) {
    dates = props.hvi.personal.map((hviData) => {
      hviValues.push(hviData.hvi_count);

      return hviData.date;
    });
  }

  if (props.hvi.organization && props.hvi.organization.length > 0) {
    props.hvi.organization.map((userdata) => {
      userdata.member_hvi.data.map((hvidata, index) => {
        if (index < 12) {
          if ( hvidata.value === 0 || hvidata.value === 1 || hvidata.value === 2 ) {
            teamHvi.red[index] = teamHvi.red[index] + 1;
          }

          if (hvidata.value === 3 || hvidata.value === 4) {
            teamHvi.yellow[index] = teamHvi.yellow[index] + 1;
          }

          if (hvidata.value === 5 || hvidata.value === 6) {
            teamHvi.green[index] = teamHvi.green[index] + 1;
          }
        }

        return hvidata;
      });

      if (userdata.member_hvi_all && userdata.member_hvi_all.length > 0) {
        userdata.member_hvi_all.map((allHvi) => {
          
          //console.log( getWeekNumber(allHvi.date) );

          const dateWeek = getWeekNumber(allHvi.date);

          if ( ! teamWeeks.includes( dateWeek ) ) {

            let teamHviWeeklyFiltered = {
              red: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
              yellow: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
              green: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            };

            let red = 0;
            let yellowOne = 0;
            let yellowTwo = 0;
            let green = 0;

            allHvi.data.map((hvidata, index) => {
              if (index < 12) {

                if ( hvidata.value === 0 || hvidata.value === 1 || hvidata.value === 2 ) {
                  teamHviWeeklyFiltered.red[index] = teamHviWeeklyFiltered.red[index] + 1;
                }

                if (hvidata.value === 3 || hvidata.value === 4) {
                  teamHviWeeklyFiltered.yellow[index] = teamHviWeeklyFiltered.yellow[index] + 1;
                }

                if (hvidata.value === 5 || hvidata.value === 6) {
                  teamHviWeeklyFiltered.green[index] = teamHviWeeklyFiltered.green[index] + 1;
                }
              }

              return hvidata;
            });

            if ( allHvi.hvi_count > 12 && allHvi.hvi_count <= 24 ) {
              red = red + 1;
            }

            if ( allHvi.hvi_count > 24 &&  allHvi.hvi_count <= 41 ) {
                yellowOne = yellowOne + 1; 
            }

            if ( allHvi.hvi_count >= 60 ) {
                green = green + 1;
            }

            if ( allHvi.hvi_count >= 42 &&  allHvi.hvi_count <= 59 ) {
                yellowTwo = yellowTwo + 1;
            }

            teamWeeks.push( dateWeek );

            const yearDate = new Date( allHvi.date );
            
            teamHviWeeklySummaryData.push({
              week: dateWeek,
              date: allHvi.date,
              year: yearDate?.getFullYear(),
              hvival: allHvi.hvi_count,
              items: 1,
              hvi_sum: teamHviWeeklyFiltered,
              red: red,
              yellow_one: yellowOne,
              yellow_two: yellowTwo,
              green: green,
            });

          } else {

            teamHviWeeklySummaryData.find((o, i) => {
              if ( o.week === dateWeek ) {
                const items = teamHviWeeklySummaryData[i].items + 1;
                const hviVal = teamHviWeeklySummaryData[i].hvival + allHvi.hvi_count;

                let teamHviWeeklyFiltered = teamHviWeeklySummaryData[i].hvi_sum;

                let red = teamHviWeeklySummaryData[i].red;
                let yellowOne = teamHviWeeklySummaryData[i].yellow_one;
                let yellowTwo = teamHviWeeklySummaryData[i].yellow_two;
                let green = teamHviWeeklySummaryData[i].green;

                allHvi.data.map((hvidata, index) => {
                  if (index < 12) {

                    if ( hvidata.value === 0 || hvidata.value === 1 || hvidata.value === 2 ) {
                      teamHviWeeklyFiltered.red[index] = teamHviWeeklyFiltered.red[index] + 1;
                    }

                    if (hvidata.value === 3 || hvidata.value === 4) {
                      teamHviWeeklyFiltered.yellow[index] =
                        teamHviWeeklyFiltered.yellow[index] + 1;
                    }

                    if (hvidata.value === 5 || hvidata.value === 6) {
                      teamHviWeeklyFiltered.green[index] =
                        teamHviWeeklyFiltered.green[index] + 1;
                    }
                  }

                  return hvidata;
                });

                if ( allHvi.hvi_count > 12 && allHvi.hvi_count <= 24 ) {
                  red = red + 1;
                }
    
                if ( allHvi.hvi_count > 24 &&  allHvi.hvi_count <= 41 ) {
                    yellowOne = yellowOne + 1; 
                }
    
                if ( allHvi.hvi_count >= 60 ) {
                    green = green + 1;
                }
    
                if ( allHvi.hvi_count >= 42 &&  allHvi.hvi_count <= 59 ) {
                    yellowTwo = yellowTwo + 1;
                }

                teamHviWeeklySummaryData[i].hvival = hviVal;
                teamHviWeeklySummaryData[i].items = items;
                teamHviWeeklySummaryData[i].hvi_sum = teamHviWeeklyFiltered;
                teamHviWeeklySummaryData[i].red = red;
                teamHviWeeklySummaryData[i].yellow_one = yellowOne;
                teamHviWeeklySummaryData[i].yellow_two = yellowTwo;
                teamHviWeeklySummaryData[i].green = green;

                return true; // stop searching
              }

              return false;
            });

          }

          if (!teamDates.includes(allHvi.date)) {
            let teamHviFiltered = {
              red: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
              yellow: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
              green: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            };

            allHvi.data.map((hvidata, index) => {
              if (index < 12) {

                if ( hvidata.value === 0 || hvidata.value === 1 || hvidata.value === 2 ) {
                  teamHviFiltered.red[index] = teamHviFiltered.red[index] + 1;
                }

                if (hvidata.value === 3 || hvidata.value === 4) {
                  teamHviFiltered.yellow[index] =
                    teamHviFiltered.yellow[index] + 1;
                }

                if (hvidata.value === 5 || hvidata.value === 6) {
                  teamHviFiltered.green[index] =
                    teamHviFiltered.green[index] + 1;
                }
              }

              return hvidata;
            });

            teamDates.push(allHvi.date);
            
            teamHviSummaryData.push({
              date: allHvi.date,
              hvival: allHvi.hvi_count,
              items: 1,
              hvi_sum: teamHviFiltered
            });

          } else {
            teamHviSummaryData.find((o, i) => {
              if (o.date === allHvi.date) {
                const items = teamHviSummaryData[i].items + 1;
                const hviVal = teamHviSummaryData[i].hvival + allHvi.hvi_count;

                let teamHviFiltered = teamHviSummaryData[i].hvi_sum;

                allHvi.data.map((hvidata, index) => {
                  if (index < 12) {

                    if (
                      hvidata.value === 0 ||
                      hvidata.value === 1 ||
                      hvidata.value === 2
                    ) {
                      teamHviFiltered.red[index] =
                        teamHviFiltered.red[index] + 1;
                    }

                    if (hvidata.value === 3 || hvidata.value === 4) {
                      teamHviFiltered.yellow[index] =
                        teamHviFiltered.yellow[index] + 1;
                    }

                    if (hvidata.value === 5 || hvidata.value === 6) {
                      teamHviFiltered.green[index] =
                        teamHviFiltered.green[index] + 1;
                    }
                  }

                  return hvidata;
                });

                teamHviSummaryData[i].hvival = hviVal;
                teamHviSummaryData[i].items = items;
                teamHviSummaryData[i].hvi_sum = teamHviFiltered;

                return true; // stop searching
              }

              return false;
            });
          }

          return allHvi;
        });
      }

      return userdata;
    });
  }

  const sortedJsObjects = teamHviSummaryData.sort((a, b) => {
    const dateA = new Date(a.date);
    const dateB = new Date(b.date);
    return dateB - dateA;
  });

  const sortedJsObjectsWeekly = teamHviWeeklySummaryData.sort((a, b) => {
    const dateA = new Date(a.date);
    const dateB = new Date(b.date);
    return dateB - dateA;
  });

  const teamHviSummaryDataSorted = sortedJsObjects.reverse();
  const teamHviSummaryDataSortedWeekly = sortedJsObjectsWeekly.reverse();
  let teamDatesSorted = [];
  let teamHviSum = [];
  let teamWeeksSorted = [];
  let teamHviSumWeekly = [];

  // Get only items that have been answered by more than 30% of the organization.
  const teamHviSummaryFiltered = [];
  const teamHviSummaryFilteredWeekly = [];

  teamHviSummaryDataSorted.map((obj) => {
    const thirtyPercent = props?.hvi?.members_count * 0.3;

    if (obj.items > thirtyPercent) {
      teamHviSummaryFiltered.push(obj);
    }

    return obj;
  });

  teamHviSummaryDataSortedWeekly.map((obj) => {
    const thirtyPercent = props?.hvi?.members_count * 0.3;

    if (obj.items > thirtyPercent) {
      teamHviSummaryFilteredWeekly.push(obj);
    }

    return obj;
  });

  teamHviSummaryFiltered.map((obj) => {
    if (!teamDatesSorted.includes(obj.date)) {
      teamDatesSorted.push(obj.date);
    }

    const sum = parseInt(obj.hvival / obj.items, 10);
    teamHviSum.push(sum);

    return obj;
  });

  teamHviSummaryFilteredWeekly.map((obj, index ) => {
    
    let weekString = `v${obj.week}`;

    // Include the year in first entry
    if ( index === 0 ) {
      weekString = `${obj.year}-v${obj.week}`;
    }

    if ( index > 0 ) {

      const prevIndex = index - 1;

      if ( teamHviSummaryFilteredWeekly[prevIndex]?.year !== obj.year ) {
        weekString = `${obj.year}-v${obj.week}`;
      }
    }

    if (!teamWeeksSorted.includes(weekString)) {
      teamWeeksSorted.push(weekString);
    }

    const sum = parseInt(obj.hvival / obj.items, 10);
    teamHviSumWeekly.push(sum);

    return obj;
  });

  //console.log( teamWeeksSorted );
  //console.log( teamHviSumWeekly );

  //const sorted = teamHviSummaryData.sort(sortByDate);
  //console.log( sortedJsObjects );

  // teamHviSummaryData.map( (hviData) => {

  // });

  if (props.hvi.organization && props.hvi.organization.length > 0) {
    teamHvi.red.map(
      (hvival, index) =>
        (teamHvi.red[index] = parseInt(
          (hvival * 100) / props.hvi.organization.length,
          10
        ))
    );
    teamHvi.yellow.map(
      (hvival, index) =>
        (teamHvi.yellow[index] = parseInt(
          (hvival * 100) / props.hvi.organization.length,
          10
        ))
    );
    teamHvi.green.map(
      (hvival, index) =>
        (teamHvi.green[index] = parseInt(
          (hvival * 100) / props.hvi.organization.length,
          10
        ))
    );

    teamHviSummaryFiltered.map((summaryItem) => {
      summaryItem.hvi_sum.red.map(
        (hvival, index) =>
          (summaryItem.hvi_sum.red[index] = parseInt(
            (hvival * 100) / summaryItem.items,
            10
          ))
      );
      summaryItem.hvi_sum.yellow.map(
        (hvival, index) =>
          (summaryItem.hvi_sum.yellow[index] = parseInt(
            (hvival * 100) / summaryItem.items,
            10
          ))
      );
      summaryItem.hvi_sum.green.map(
        (hvival, index) =>
          (summaryItem.hvi_sum.green[index] = parseInt(
            (hvival * 100) / summaryItem.items,
            10
          ))
      );

      return summaryItem;
    });

    teamHviSummaryFilteredWeekly.map((summaryItem) => {
      summaryItem.hvi_sum.red.map(
        (hvival, index) =>
          (summaryItem.hvi_sum.red[index] = parseInt(
            (hvival * 100) / summaryItem.items,
            10
          ))
      );
      summaryItem.hvi_sum.yellow.map(
        (hvival, index) =>
          (summaryItem.hvi_sum.yellow[index] = parseInt(
            (hvival * 100) / summaryItem.items,
            10
          ))
      );
      summaryItem.hvi_sum.green.map(
        (hvival, index) =>
          (summaryItem.hvi_sum.green[index] = parseInt(
            (hvival * 100) / summaryItem.items,
            10
          ))
      );

      return summaryItem;
    });
  }

  //const teamHviSummaryFilteredReversed = teamHviSummaryFiltered;
  //console.log( teamHviSummaryData );

  //const datesOriginal = dates;

  let datesMerged = [];
  let datesMergedUniq = [];
  let mergedHviValues = [];
  let mergedTeamHviSum = [];
  let mergedTeamHViData = [];

  if (props.organization) {
    datesMerged = [...dates, ...teamDatesSorted];
    datesMerged = datesMerged.sort();

    datesMergedUniq = [...new Set(datesMerged)];

    if (datesMergedUniq) {
      datesMergedUniq.map((itemDate) => {
        const datesIndex = dates.findIndex((date) => date === itemDate);
        const teamDatesIndex = teamDatesSorted.findIndex(
          (date) => date === itemDate
        );
        const summaryIndex = teamHviSummaryFiltered.findIndex(
          (item) => item.date === itemDate
        );

        if (datesIndex !== -1) {
          mergedHviValues.push(hviValues[datesIndex]);
        } else {
          mergedHviValues.push(null);
        }

        if (teamDatesIndex !== -1) {
          mergedTeamHviSum.push(teamHviSum[teamDatesIndex]);
        } else {
          mergedTeamHviSum.push(null);
        }

        if (summaryIndex !== -1) {
          mergedTeamHViData.push(teamHviSummaryFiltered[summaryIndex]);
        } else {
          mergedTeamHViData.push({});
        }

        return itemDate;
      });

    }
  }

  let recentHviCount = 0;

  let userRoles = [];

  if ( props?.roles ) {
      userRoles = Object.values( props?.roles );
  }

  if (props.hvi?.personal?.length > 0) {
    let lastIndex = props.hvi?.personal?.length - 1;

    if (!lastIndex || lastIndex < 0) {
      lastIndex = 0;
    }

    const recentHviItem = props.hvi.personal[lastIndex];

    if (recentHviItem) {
      recentHviCount = recentHviItem.hvi_count;
    }
  }

  return (
    <div className="hvi-chart-wrap mt-3">
      <div className="row">
        <div className={`${props?.gtg && props?.capabilities && props?.capabilities.includes('nvi') ? 'col-12 col-lg-6' : 'col-12'}`}>
          {/* <h3 className="border-bottom pb-2 mb-4">HVI</h3> */}

          {(props?.organization !== 0 && props?.organization !== '' ) && window.location.pathname !== "/" && (
            <PersonalLinear
              dates={ teamHviSumWeekly.length > 0 ? teamWeeksSorted : datesMergedUniq}
              hviValues={[mergedHviValues, teamHviSumWeekly]}
              loading={props.loading}
              type="team"
              summary={teamHviSummaryFilteredWeekly}
              organization={props.organization}
              dataFetched={props?.dataFetched}
            />
            
          )}

          {(!props.organization || props.organization === 0 ) && window.location.pathname !== "/" && (
            <PersonalLinear
              dates={dates}
              hviValues={[hviValues, []]}
              loading={props.loading}
              type="personal"
              organization={props.organization}
            />
          )}

          { window.location.pathname === "/" &&
            <div className="bg-white w-100 pt-2" style={{height: "336px"}}>

              <div className="d-flex flex-column h-100">
                <div className="p-3 pt-0">
                  <div className="d-flex align-items-center">
                    <h5 className="flex-grow-1">{translation('hvi_title')}</h5>
                    <span className="display-6">{recentHviCount}</span>
                  </div>

                  <p className={`opacity-half font-size-medium mb-0 mt-1 ${hviValues && hviValues.length > 0 ? '' : 'bg-sy-gray text-white p-3 rounded mt-3'}`}>
                    { hviValues && hviValues.length > 0 ? translation('hvi_dash_desc') : translation('no_hwi_data')}
                  </p>
                  
                  <div className="d-flex mt-3">
                    <Link to="/hvi/" className="btn btn-secondary rounded-pill font-size-medium me-2" >
                      <span className="pe-2">{translation('go_to_test')}</span>
                      <i className="fa fa-angle-right" aria-hidden="true"></i>
                    </Link>

                    {hviValues && hviValues.length > 0 &&
                      <Link to={`hvi/?count=${recentHviCount}`} className="btn btn-secondary rounded-pill font-size-medium" >
                        <span className="pe-2">Se tidigare</span>
                        <i className="fa fa-angle-right" aria-hidden="true"></i>
                      </Link>
                    }
                    
                  </div>

                  {/* <span className="display-1">{recentHviCount}</span> */}
                </div>

                {hviValues && hviValues.length > 0 &&
                  <div className="mt-auto">
                    <TeamDataColumnChart data={hviValues}  dates={dates} />
                  </div>
                }

              </div>
              
            </div>
          }

          {recentHviCount > 0 && window.location.pathname !== "/" && (
            <div className="text-end">
              <Link
                to={`hvi/?count=${recentHviCount}`}
                className="text-secondary d-inline-block text-decoration-none"
              >
                <span className="pe-2">{translation('view_all_hwi')}</span>
                <i className="fa fa-angle-right" aria-hidden="true"></i>
              </Link>
            </div>
          )}
        </div>

        { props?.gtg && props?.capabilities && props?.capabilities.includes('nvi') &&
            <div className="col-12 col-lg-6">
            {/* <h3 className="border-bottom pb-2 mb-4">Grå till guld</h3> */}
            <GrayToGoldLinear loading={props.loading} />
          </div>
        }

      </div>
            
            {(props?.organization !== 0 && props?.organization !== '' ) && window.location.pathname !== "/" && teamHviSummaryFilteredWeekly && teamHviSummaryFilteredWeekly.length > 0 &&
              <>
                 <div className="row">
                        <div className="col-12">
                            <div className="d-flex my-4 align-items-center">
                                {/* <h3 className="flex-grow-1">Team HVI</h3> */}
                                <div className="border-top pt-4 w-100">
                                    { teamHviSummaryFilteredWeekly.map( (item, index) => {
                                        let weekString = `v${item.week}`;

                                        // Include the year in first entry
                                        if ( index === 0 ) {
                                          weekString = `${item.year}-v${item.week}`;
                                        }
                                    
                                        if ( index > 0 ) {
                                    
                                          const prevIndex = index - 1;
                                    
                                          if ( teamHviSummaryFilteredWeekly[prevIndex]?.year !== item.year ) {
                                            weekString = `${item.year}-v${item.week}`;
                                          }
                                        }
                                        return (
                                            <button className={`btn btn-small mb-2 rounded-pill ${selectedHviItem === index ? 'btn-halite-blue text-white' : 'btn-white bg-white'} ms-2`} key={index} onClick={ () => setSelectedHviItem(index) }>{weekString}</button>
                                        )
                                    }) }
                                </div>
                            </div>
                        </div>
                  </div>

                  <div className="row mb-4">
                    <div className="col-12 col-lg-6">
                        <OfflineColumnChart totalUsers={teamHviSummaryFilteredWeekly[selectedHviItem].items} 
                          data={
                            [
                              teamHviSummaryFilteredWeekly[selectedHviItem].red,
                              teamHviSummaryFilteredWeekly[selectedHviItem].yellow_one,
                              teamHviSummaryFilteredWeekly[selectedHviItem].yellow_two,
                              teamHviSummaryFilteredWeekly[selectedHviItem].green,
                            ]
                          } 
                        />
                    </div>
                    <div className="col-12 col-lg-6">
                        <OfflinePieChart totalUsers={teamHviSummaryFilteredWeekly[selectedHviItem].items} 
                          data={
                            [
                              teamHviSummaryFilteredWeekly[selectedHviItem].red,
                              teamHviSummaryFilteredWeekly[selectedHviItem].yellow_one,
                              teamHviSummaryFilteredWeekly[selectedHviItem].yellow_two,
                              teamHviSummaryFilteredWeekly[selectedHviItem].green,
                            ]
                          } 
                        />
                    </div>
                  </div>

                  <div className="row">
                      
                  <div className={`col-12 ${ (userRoles.includes('sustainchange_manager') || userRoles.includes('sustainchange_owner') ) ? 'col-lg-9' : ''}`}>
                      <TeamBars
                        hviValues={teamHviSummaryFilteredWeekly[selectedHviItem].hvi_sum} 
                        loading={props.loading} 
                        title="Team HWI - fördelning per fråga"
                        questions={[
                            'Meningsfullhet i vardagen',
                            'Kontroll över vardagsstressen',
                            'Tillräckligt med återhämtning',
                            'Tillräckligt med sömn',
                            'Balans mellan krav och resurser på jobbet',
                            'Balans mellan krav och resurser hemma',
                            'Ork på jobbet',
                            'Ork hemma',
                            'Nöjd med arbetsinsatsen',
                            'Nöjd med fritiden',
                            'Kan koppla bort jobbet när man är ledig',
                            'Kan koppla bort privata frågor när man jobbar'
                        ]}
                        />
                    </div>  

                    { (userRoles.includes('sustainchange_manager') || userRoles.includes('sustainchange_owner')) && 
                       <div className="col-12 col-lg-3">
                          <ProductivityChart 
                              hviValues={teamHviSummaryFilteredWeekly[selectedHviItem].hvi_sum} 
                              loading={props.loading}
                              members={props?.hvi?.members_count}
                              organization={props?.organization}
                          />
                       </div>
                    }

                  </div>
              </>
            }
    </div>
  );
};

export default HviChart;
